export const ABORT_ERROR_NAME = 'AbortError' as const;

export class AbortError extends Error {
  name = ABORT_ERROR_NAME;
}
